import React from 'react';
import { CheckIcon } from 'lucide-react';
const assurances = ['Accès immédiat', '100 % numérique', 'Paiement unique'];
export function AssuranceRow({
  tone = 'light',
  className = ''
}: {
  tone?: 'light' | 'dark';
  className?: string;
}) {
  const text = tone === 'dark' ? 'text-brand-ivory/75' : 'text-brand-charcoal/60';
  const icon = tone === 'dark' ? 'text-brand-butter' : 'text-brand-cta';
  return <ul className={`flex flex-wrap justify-center gap-x-5 gap-y-2 ${className}`} role="list" data-id="element-44" data-mp="34xo1yqfxl8pw">
      {assurances.map(label => <li key={label} className={`flex items-center gap-1.5 font-body text-[12px] ${text}`} data-id="element-45" data-mp="2zyunauowrbo5">
          <CheckIcon className={`h-3.5 w-3.5 ${icon}`} strokeWidth={2.5} aria-hidden="true" data-id="element-46" data-mp="3evbud9q2e44w" />
          {label}
        </li>)}
    </ul>;
}